export default "__VITE_ASSET__CjyUeD6l__"